import axios from "axios";

// Empty string is intentional and preferred for local dev: axios then uses
// relative /v1/* paths and CRA's dev proxy (package.json "proxy") forwards
// them to the API. `undefined` (env var not set at all) falls back to the
// same-origin default.
const RAW = process.env.REACT_APP_BACKEND_URL;
const BACKEND_URL = RAW === undefined ? "" : RAW.replace(/\/+$/, "");
export const API_BASE = `${BACKEND_URL}/v1`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("dyntra_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiError(err) {
  const d = err?.response?.data;
  const detail = d?.detail ?? d?.message;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || e?.message || JSON.stringify(e)).join(", ");
  return String(detail);
}
